import React from 'react';

export type TextLineSelection = {
	page: number;
	bounds: number[];
} | null;

export type EditorSelectionContextProps = {
	selectedTextLine: TextLineSelection;
	setSelectedTextLine: React.Dispatch<React.SetStateAction<TextLineSelection>>;
};

export const EditorSelectionContext =
	React.createContext<EditorSelectionContextProps>({
		selectedTextLine: null,
	} as EditorSelectionContextProps);
